import PanelGroup from 'apollo-react/components/PanelGroup';
import React from 'react';

// PanelGroup is empty div in tests
const PanelWrapper = ({ children, classes }) =>
  process.env.NODE_ENV === 'test' ? (
    <div>{children}</div>
  ) : (
    <PanelGroup className={classes.panelGroup}>{children}</PanelGroup>
  );

export default PanelWrapper;
